"use strict";

var toDate = function toDate(value) {
  return value instanceof Date ? value : new Date(value);
};

module.exports = toDate;